import classNames from 'classnames'
import React, { ComponentType } from 'react'

import type { IconProps } from '../icon/icon.js'

export interface MenuItemProps {
    icon: ComponentType<IconProps>
    label: string
    isCurrent?: boolean
    url: string
}

export const MenuItem = (props: MenuItemProps) => (
    <a className={classNames('menu-item', props.isCurrent && 'menu-item--current')} href={props.url}>
        <props.icon className="menu-item__icon" />
        <span className="menu-item__label">{props.label}</span>
    </a>
)
